<template>
    <default-layout>
        <SpainhnNavigationBreadcrumb :navigation-links="links">
            <slot>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" role="button" @click="goToExperiences" v-bind:class="{ 'd-none': (experiencias == 0), 'd-inline-block':experiencias }">{{ $t('default.SERVICES_BAR_EXPERIENCES')}}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (experiencias == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" v-bind:class="{'d-none':!bodas}" @click="goToBodas" role="button">{{ $t('default.SERVICES_BAR_WEDDING')}}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (bodas == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" v-bind:class="{'d-none':!espacios}" role="button" @click="goToEspacios">{{ $t('default.SERVICES_BAR_SPACES')}}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (espacios == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" @click="goToMuseo" role="button" v-bind:class="{'d-none':!museo}">{{ $t('default.SERVICES_BAR_MUSEUM')}}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (museo == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" @click="goToRestaurante" role="button" v-bind:class="{'d-none':!restaurante}">{{ $t('default.SERVICES_BAR_RESTAURANT') }}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (restaurante == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
                    <small class="spainhn-small-text text-white my-auto px-1 variable-item" role="button" @click="goToAlojamiento" v-bind:class="{'d-none':!alojamiento}">{{ $t('default.SERVICES_BAR_ACCOMMODATION')}}</small>
                    <svg class="mx-1 my-auto" xmlns="http://www.w3.org/2000/svg" width="2" height="14" viewBox="0 0 2 14" fill="none" v-bind:class="{ 'd-none': (alojamiento == 0)}">
                        <path d="M1 0V13.5" stroke="white"/>
                    </svg>
    
                    <small class="spainhn-small-text text-white my-auto px-1 flex-grow-1 text-start variable-item" @click="goToContact" role="button">{{ $t('default.SERVICES_BAR_CONTACT')}}</small>
            </slot>
        </SpainhnNavigationBreadcrumb>

        <white-loader :loading="loading"/>
        <div class="container-fluid px-2 px-md-5 margen-estandard mergen-cards">
            <div class="d-flex justify-content-around pt-2 mb-2 px-lg-4 flex-column">
                <div v-if="agrupacionInfo && agrupacionInfo.length > 1" class="monumentos-tabs">
                    <b-tabs 
                        v-model="activeTab" 
                        content-class="mt-2"
                        nav-class="custom-tabs"
                        active-nav-item-class="custom-active-tab"
                        >
                        <b-tab 
                            v-for="(monumento) in agrupacionInfo" 
                            :key="monumento._id"
                            :title="monumento.nombre"
                            :active="monumento._id === castilloId"
                            @click="handleTabClick(monumento)"
                        >
                        </b-tab>
                    </b-tabs>
                </div>
                <div class="d-flex px-lg-4 mt-4">
                    <icon-base :width="12" :height="12" 
                        :iconColor="'rgb(0,0,0)'" id="icono-castillo">
                        <icon-casttle></icon-casttle>
                    </icon-base>
                    <div class="ms-3 h-100 d-flex flex-column text-start">
                        <p class="mb-0 mt-auto pb-0 spainhn-subtitle-2-black" v-html="nombreDeMonumentoPorIdioma"></p>
                        <small class="mb-0 mt-0 spainhn-subtitle-4-black pt-0">{{address}}</small>
                    </div>
                </div>
            </div>

            <div class="container-fluid px-0">
                <div class="row ps-lg-4 pe-0 gx-2">
                    <div class="text-start spainhn-text pt-0 pe-0 mb-1 mb-md-5 col-xxl-8 col-12 px-0" style="height:100%">
                        <b-carousel
                            id="monumentosShow"
                            v-model="slide"
                            :interval="4000"
                            controls
                            indicators
                            img-width="940"
                            img-height="528"
                            style="text-shadow: 1px 1px 2px #333;"
                            @sliding-start="onSlideStart"
                            @sliding-end="onSlideEnd"
                        >
                            <b-carousel-slide v-for="(imagen, index) in imagenes" v-bind:key="index">
                                <template #img>
                                    <div class="mb-3 d-flex mx-auto carousel-homeslide px-0 mx-0" style="height:344px; width:940px; max-width: 100%;">
                                        <img
                                            class="my-md-auto mx-auto carousel-spainhn"
                                            style="height:auto; width:auto; max-width:940px; max-height:344px; display: block;"
                                            :src="`${imagenesUrl}/monumentos/${monumentoOldId}/${imagen.name}`"
                                            :alt="imagen.altText"
                                        >
                                    </div>
                                </template>
                            </b-carousel-slide>

                            <a class="carousel-control-prev" aria-controls="monumentosShow___BV_inner_" role="button" data-slide="prev">
                                <!-- INSERT MY OWN PREV ICON USING FONT AWESOME  -->
                                <font-awesome-icon icon="fa-circle" size="3x" class="text-black"></font-awesome-icon>
                                <span class="sr-only">Previous</span>
                            </a>

                            <a class="carousel-control-next" role="button" data-slide="next" aria-controls="monumentosShow___BV_inner_">
                                <!-- INSERT MY OWN PREV ICON USING FONT AWESOME  -->
                                <font-awesome-icon icon="fa-circle" size="3x" class="text-black"></font-awesome-icon>
                                <span class="sr-only">Previous</span>
                            </a>

                        </b-carousel>

                        <div class="overflow-hidden mx-auto mt-2 d-md-block d-none" style="height:94.5px; width:940px; max-width:100%; position:relative;" id="imageSelectorContainer">
                            <div class="d-flex thumbnails-container" style="height:94.5px; width:940px; max-width:72vw; position:relative;" ref="imageSelector" id="imageSelector">
                                <div style="height:94.5px; width:140px;" class="thumbnail-slide" v-for="(imagen, index) in imagenes" v-bind:key="index">
                                    <img role="button" @click="changeSlide(index)"
                                        class="px-1"
                                        style="height:100%; width:140px; object-fit: cover;  border-radius: 15px;"
                                        :src="`${imagenesUrl}/monumentos/${monumentoOldId}/${imagen.name}`"
                                        :alt="imagen.altText">                        
                                </div>
                            </div>
                        </div>

                        <div class="d-flex justify-content-around pt-0 pt-md-2 mb-0 px-lg-2 px-md-0 mx-auto" style="padding: 0 15px 0 15px;">
                            <div class="d-flex px-lg-4 align-middle" style="width:100%; position: relative; min-height: 54px; position: relative;">

                                <div class="ms-md-auto ms-lg-0 mb-auto icon-container">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" viewBox="0 0 31 25" fill="none">
                                        <path d="M30.4841 24.491C30.4695 24.491 30.455 24.491 30.4404 24.491H28.8407L27.5754 10.6021V10.5876V8.26062H28.608C28.7534 8.26062 28.8698 8.14427 28.8698 7.99884V5.42467C28.8698 5.27923 28.7534 5.16289 28.608 5.16289H27.3136C27.1682 5.16289 27.0518 5.27923 27.0518 5.42467V6.45724H26.281V4.13031C26.281 3.98487 26.1647 3.86853 26.0193 3.86853H23.7069V2.99593L26.1356 1.77429C26.2665 1.70157 26.3101 1.55614 26.252 1.42525C26.2229 1.38162 26.1938 1.33799 26.1356 1.3089L23.5905 0.04363L23.5614 0.0290867C23.5469 0.0145433 23.5324 0.0145433 23.5178 0.0145433C23.5178 0.0145433 23.5033 0.0145433 23.5033 0C23.4887 0 23.4596 0 23.4451 0C23.4306 0 23.4306 0 23.416 0C23.4015 0 23.3869 0 23.3724 0H23.3578C23.3433 0 23.3287 0.0145433 23.3287 0.0145433C23.3142 0.0145433 23.2997 0.0290867 23.2997 0.04363C23.2851 0.04363 23.2851 0.0581734 23.2706 0.0727167C23.2706 0.0727167 23.256 0.101803 23.2415 0.116347C23.2415 0.116347 23.2415 0.13089 23.2269 0.13089V0.145433C23.2269 0.145433 23.2269 0.159977 23.2269 0.17452C23.2269 0.189063 23.2269 0.203607 23.2269 0.21815V0.232693V3.83944H22.1944C22.0489 3.83944 21.9326 3.95579 21.9326 4.10122V6.42816H21.1618V5.39558C21.1472 5.25015 21.0309 5.14834 20.8855 5.16289H19.6057C19.4602 5.16289 19.3439 5.27923 19.3439 5.41012V7.98429C19.3439 8.12973 19.4602 8.24607 19.5911 8.24607H20.6237V10.5585L20.2892 14.1798H15.9989V13.1908C15.9989 13.1763 15.9989 13.1763 15.9989 13.1617V13.1326C15.9989 13.1181 15.9989 13.1035 15.9844 13.089V13.0745C15.9844 13.0599 15.9698 13.0454 15.9698 13.0308L15.9553 13.0017L14.69 10.4712C14.6173 10.3403 14.4428 10.2967 14.3264 10.3839C14.2828 10.413 14.2537 10.4421 14.2392 10.4712L12.9739 13.0017C12.9739 13.0017 12.9739 13.0017 12.9593 13.0163L12.9448 13.0454C12.9303 13.0599 12.9303 13.0745 12.9303 13.1035C12.9303 13.1181 12.9303 13.1326 12.9303 13.1617V14.2088H9.87616L9.55621 10.5876V8.26062H10.5888C10.7342 8.26062 10.8506 8.14427 10.8506 7.99884V5.42467C10.8506 5.27923 10.7342 5.16289 10.5888 5.16289H9.30897C9.16354 5.16289 9.04719 5.27923 9.04719 5.42467V6.45724H8.27639V5.42467C8.27639 5.27923 8.16005 5.16289 8.02916 5.16289H6.7348C6.58937 5.16289 6.47302 5.27923 6.47302 5.42467V6.45724H5.70222V5.42467C5.70222 5.27923 5.58588 5.16289 5.44044 5.16289H4.14608C4.00065 5.16289 3.8843 5.27923 3.8843 5.42467V6.45724H3.11351V5.42467C3.11351 5.27923 2.99716 5.16289 2.85173 5.16289H1.55737C1.41194 5.16289 1.29559 5.27923 1.29559 5.42467V7.99884C1.29559 8.14427 1.41194 8.26062 1.55737 8.26062H2.58995V10.5585L1.32468 24.4764H0.277556C0.132123 24.4619 0.015776 24.5782 0.00123267 24.7091C-0.0133107 24.84 0.103036 24.9709 0.233926 24.9855C0.248469 24.9855 0.263013 24.9855 0.277556 24.9855H1.51374C1.52828 24.9855 1.52828 24.9855 1.54283 24.9855H1.57191C1.58646 24.9855 1.601 24.9855 1.63009 24.9855H10.5597C10.5742 24.9855 10.5742 24.9855 10.5888 24.9855H24.7685C24.7831 24.9855 24.7831 24.9855 24.7976 24.9855H30.4695C30.615 25 30.7313 24.8837 30.7459 24.7528C30.7604 24.6219 30.6295 24.491 30.4841 24.491ZM23.7214 0.69808L25.4666 1.57068L23.7214 2.44328V0.69808ZM21.1472 10.3258V8.26062H27.0809V10.3258H21.1472ZM22.4416 4.39209H25.7866V5.16289H24.754C24.6086 5.16289 24.4922 5.27923 24.4922 5.42467V6.45724H23.7214V5.42467C23.7214 5.27923 23.6051 5.16289 23.4742 5.16289H22.4416V4.39209ZM19.8529 7.7516V5.68645H20.6237V6.71902C20.6237 6.86446 20.74 6.9808 20.8855 6.9808H22.1798C22.3253 6.9808 22.4416 6.86446 22.4416 6.71902V5.68645H23.2269V6.71902C23.2269 6.86446 23.3433 6.9808 23.4887 6.9808H24.7831C24.9285 6.9808 25.0449 6.86446 25.0449 6.71902V5.68645H25.8157V6.71902C25.8157 6.86446 25.932 6.9808 26.0774 6.9808H27.3718C27.5172 6.9808 27.6336 6.86446 27.6336 6.71902V5.68645H28.4044L28.3607 7.7516H19.8529ZM14.4573 11.1547L15.3299 12.8999H13.5847L14.4573 11.1547ZM13.4247 13.409H15.4899V15.4887H13.4247V14.7179V14.2088V13.409ZM12.9012 14.7179V15.7359C12.9012 15.8813 13.0175 15.9977 13.163 15.9977H15.7371C15.8826 15.9977 15.9989 15.8813 15.9844 15.7359V14.7179H21.9908L23.0961 18.0628H22.1362C22.1217 18.0628 22.1071 18.0628 22.0926 18.0628C22.078 18.0628 22.0635 18.0628 22.0489 18.0628H10.2397L9.93433 14.7179H12.9012ZM23.7214 20.8842V19.8662H24.4922V24.491H10.8215L10.5161 21.146C10.5452 21.146 10.5597 21.146 10.5888 21.146H22.0489C22.0635 21.146 22.0926 21.146 22.1071 21.146C22.1217 21.146 22.1507 21.146 22.1653 21.146H23.4742C23.6051 21.1315 23.7214 21.0151 23.7214 20.8842ZM13.4247 20.6225V20.2298C13.4247 20.0116 13.5993 19.8517 13.8174 19.8517C14.0356 19.8517 14.2101 20.0262 14.2101 20.2298V20.6225H13.4247ZM15.9989 20.6225V20.2298C16.0134 20.0116 16.2025 19.8517 16.4061 19.8662C16.5952 19.8807 16.7552 20.0407 16.7697 20.2298V20.6225H15.9989ZM18.5731 20.6225V20.2298C18.5876 20.0116 18.7767 19.8517 18.9803 19.8662C19.1694 19.8807 19.3293 20.0407 19.3439 20.2298V20.6225H18.5731ZM19.8674 20.637V20.2589C19.8674 19.7644 19.4602 19.3572 18.9657 19.3572C18.4713 19.3572 18.0641 19.7644 18.0641 20.2589V20.637H17.2933V20.2589C17.2933 19.7644 16.886 19.3572 16.3916 19.3572C15.8971 19.3572 15.4899 19.7644 15.4899 20.2589V20.637H14.7191V20.2589C14.7045 19.7644 14.2828 19.3717 13.7738 19.3863C13.3084 19.4008 12.9303 19.7789 12.9012 20.2589V20.637H10.5742C10.5306 20.637 10.5015 20.6515 10.4579 20.6661L10.2688 18.5864H21.8308V20.637H19.8674ZM1.81915 7.7516V5.68645H2.58995V6.71902C2.58995 6.86446 2.70629 6.9808 2.85173 6.9808H4.14608C4.29152 6.9808 4.40786 6.86446 4.40786 6.71902V5.68645H5.17866V6.71902C5.17866 6.86446 5.29501 6.9808 5.44044 6.9808H6.7348C6.88023 6.9808 6.99658 6.86446 6.99658 6.71902V5.68645H7.76738V6.71902C7.76738 6.86446 7.88372 6.9808 8.01461 6.9808H9.30897C9.4544 6.9808 9.57075 6.86446 9.57075 6.71902V5.68645H10.327V7.7516H1.81915ZM9.03265 8.26062V10.3258H3.11351V8.26062H9.03265ZM3.08442 10.8348H9.06173L9.36714 14.1798L9.41077 14.6888L10.2979 24.4764H1.84824L3.08442 10.8348ZM25.0158 24.491V19.6044C25.0158 19.459 24.8994 19.3572 24.754 19.3572H23.4596C23.3142 19.3572 23.1979 19.4735 23.1979 19.619V20.6515H22.3398V18.6009H23.4306C23.5178 18.6009 23.5905 18.5573 23.6487 18.4846C23.6923 18.4119 23.7069 18.3246 23.6778 18.2519L22.398 14.3834C22.3689 14.2816 22.2671 14.2088 22.1507 14.2088H20.7982L21.1036 10.8493H27.0809L28.3171 24.491H25.0158Z" fill="#850B0B"/>
                                        <path d="M4.786 11.6056C4.29152 11.6056 3.88431 12.0128 3.88431 12.5073V14.4415C3.88431 14.587 4.00065 14.7033 4.13154 14.7033H5.4259C5.57134 14.7033 5.68768 14.587 5.68768 14.4415V12.5073C5.68768 12.0128 5.28047 11.6056 4.786 11.6056ZM5.17866 14.1943H4.40787V12.5073C4.40787 12.2891 4.58239 12.1146 4.80054 12.1146C5.01869 12.1146 5.19321 12.2891 5.19321 12.5073V14.1943H5.17866Z" fill="#850B0B"/>
                                        <path d="M8.26184 16.3758C8.26184 15.8813 7.85463 15.4741 7.36015 15.4741C6.86568 15.4741 6.45847 15.8813 6.45847 16.3758V18.3101C6.45847 18.4555 6.57481 18.5719 6.72025 18.5719H8.00006C8.14549 18.5719 8.26184 18.4555 8.26184 18.3246V16.3758ZM6.98203 18.0483V16.3758C6.99657 16.1577 7.18563 15.9977 7.38924 16.0122C7.5783 16.0268 7.73828 16.1867 7.75282 16.3758V18.0483H6.98203Z" fill="#850B0B"/>
                                        <path d="M25.3939 11.6056C24.8994 11.6056 24.4922 12.0128 24.4922 12.5073V14.4415C24.4922 14.587 24.6086 14.7033 24.754 14.7033H26.0338C26.1792 14.7033 26.2956 14.587 26.2956 14.4415V12.5073C26.2956 12.0128 25.9029 11.6056 25.3939 11.6056ZM25.7866 14.1943H25.0158V12.5073C25.0158 12.2891 25.1903 12.1146 25.4084 12.1146C25.6266 12.1146 25.8011 12.2891 25.8011 12.5073V14.1943H25.7866Z" fill="#850B0B"/>
                                    </svg>
                                </div>

                                <div class="ms-3 d-flex flex-column text-start me-md-auto me-lg-0 mt-1">
                                    <p class="mb-0 pb-0 spainhn-header-info">{{ nombreDeMonumentoPorIdioma }}</p>
                                    <small class="mb-0 mt-0 spainhn-subheader-info pt-0">{{address}}</small>
                                </div>

                                <buy-component pulse @goTo="goToEntradas"/>
                            </div>
                        </div>

                    </div>

                    <div class="col-12 col-xxl-4 tickets-wrapper d-none d-lg-inline-block" style="min-height:450px;">
                        <div class="row h-100 pt-0 w-100 mx-auto">
                            <div class="col-md-12 col-12 mb-2 mx-auto">  
                                <GmapMap
                                    class="mx-auto"
                                    :center="{lat:latitud, lng:longitud}"
                                    :zoom="9.7"
                                    map-type-id="terrain"
                                    style="width: 100%; height: 249px;  max-width:90vw;">

                                    <GmapMarker
                                    :key="index"
                                    v-for="(m, index) in markers"
                                    :position="m.position"
                                    :clickable="true"
                                    :draggable="false"
                                    @click="center=m.position"
                                    :icon="require('@/assets/marker-gral-small.png')"/>
                                    
                                </GmapMap>
                            </div>                            
                            <div class="col-md-12 col-12 mb-2 mx-auto" v-bind:class="{'d-none':(rutaInfo?.rutaId == null)}">
                                <h5 class="spainhn-sections-title">{{ $t('default.ROUTES_KNOW_ROUTES') }}</h5>
                                <RutasCard
                                class="mx-auto"
                                @goToRutas="() => masRutas()"
                                :imageUrl="`${imagenesUrl}/rutas/logo/${rutaInfo?.rutaId}`"
                                :title="rutaInfo?.webName"/>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <div class="container-fluid ps-lg-4 pe-lg-3 cultural-visit">
                <div class="row ps-lg-4 pe-lg-3">
                    <div class="text-start spainhn-text pt-0 pe-3 col-12 col-xxl-8 order-0">
                        <!-- <h2 class="mb-2" style="font-size:28pt; font-weight:700;">{{ $t('default.MICROSITES_DESCRIPTION') }}</h2> -->
                        <span class="mb-2 spainhn-sections-title text-uppercase">{{ $t('default.MICROSITES_DESCRIPTION') }}</span>
                        <span v-bind:class="{'d-none':!audioguiaOn}" class="mt-2">
                            <div class="bg-light border p-2 mb-0 d-flex justify-content-center mx-auto align-items-center" style="max-width: 100vw;"> 
                                <small>{{ $t("default.MENSAJE_AUDIOGUIA") }}</small>
                                <div class="d-flex px-2">
                                    <b-img class="mx-auto my-auto" role="button" @click="goToAudioguia" style="width:40px; height:40px" :src="require('@/assets/audioguia-logo.png')"></b-img>
                                </div>
                            </div>
                        </span>

                        <div class="html-spacing mb-1" v-bind:class="{'html-container': !showFullText }">
                            <div v-html="micrositeData.webDescription" class="">
                            </div>
                        </div>
                        
                        <span v-bind:class="{'d-none':!podcastOn}">
                            <div class="bg-light border pt-0 px-2 pb-0">
                                <p><small>{{ $t("default.MENSAJE_PODCAST") }} {{nombreDeMonumentoPorIdioma}}</small></p>
                                <p>
                                    <iframe allowfullscreen="" frameborder="0" height="40" loading="lazy" scrolling="no" :src="podcastUrl">
                                    </iframe>
                                </p>
                            </div>
                        </span>
                        <div class="d-flex mx-auto my-2">
                            <button class="read-more-btn mx-auto spainhn-gray-background mb-1" @click="() => toggleFullText()">
                                <span v-bind:class="{'d-none': showFullText }">{{ $t("default.BUTTONS.READ_MORE") }}</span>
                                <span v-bind:class="{'d-none': !showFullText }">{{ $t("default.BUTTONS.READ_LESS") }}</span>
                            </button>
                        </div>
                    </div>

                    <mdb-container class="d-lg-none px-0 mx-0">
                        <collapsable-element 
                            v-if="micrositeData.webSchedules" 
                            :title="$t('default.MICROSITES_SCHEDULE')" class="my-2" 
                            :content="`<div style='font-size:12px;'>${zanitizeColorHTMLString(micrositeData.webSchedules)}</div>`"/>
    
                        <collapsable-element 
                            id="services-small"
                            :title="$t('default.MICROSITES_LOCATION')" class="my-2"
                            :content="`<div style='font-size: 12px;'><p><strong>${address}</strong></p>${zanitizeColorHTMLString( micrositeData.webDirections )}</div>`"/>
    
                        <collapsable-element no-divide :title="$t('default.MAIN_MENU_MINIMAP_POPOVER_SERVICES_TITLE')" class="my-2">
                            <hr v-if="bodas" style="color: black; margin-top: 0"/>
                            <collapsable-element  v-if="bodas"
                            :title="$t('default.MICROSITES_SERVICES_WEDDING_HEADER')" class="my-2"
                            :content="`<div style='font-size: 12px; color:white;'>${zanitizeColorHTMLString(micrositeData.webWeddingDescription)}</div>`"/>

                            <hr v-if="alojamiento" style="color: black; margin-top: 0"/>
                            <collapsable-element no-divide v-if="alojamiento"
                            :title="$t('default.MICROSITES_SERVICES_ACCOMMODATION_HEADER')" class="my-2"
                            :content="`<div style='font-size: 12px;'>${zanitizeColorHTMLString(micrositeData.webHostingDescription)}</div>`"/>

                            <hr v-if="espacios" style="color: black; margin-top: 0"/>
                            <collapsable-element no-divide v-if="espacios"
                            :title="$t('default.MICROSITES_SERVICES_RESERVE_SPACE_HEADER')" class="my-2"
                            :content="`<div style='font-size: 12px;'>${zanitizeColorHTMLString(micrositeData.webMiceDescription)}</div>`"/>

                            <hr v-if="restaurante" style="color: black; margin-top: 0"/>
                            <collapsable-element no-divide v-if="restaurante"
                            :title="$t('default.MICROSITES_SERVICES_RESTAURANT_HEADER')" class="my-2"
                            :content="`<div style='font-size: 12px;'>${zanitizeColorHTMLString(micrositeData.webRestauranteDescription)}</div>`"/>

                            <hr v-if="museo" style="color: black; margin-top: 0"/>
                            <collapsable-element no-divide v-if="museo"
                            :title="$t('default.MICROSITES_SERVICES_MUSEUM_HEADER')" class="my-2"
                            :content="`<div style='font-size: 12px;'>${zanitizeColorHTMLString(micrositeData.webMuseumDescription)}</div>`"/>
                        </collapsable-element>

                        <MultimediaComponent :video-id="videoId" class="text-center" :class="{'d-none': !videoId}"/>

                        <div class="d-flex flex-column justify-content-center align-items-center">
                            <span class="spainhn-sections-title text-uppercase">{{$t('default.MAIN_MENU_RUTAS')}}</span>
                            <RutasCard
                                @goToRutas="() => masRutas()"
                                :imageUrl="`${imagenesUrl}/rutas/logo/${rutaInfo?.rutaId}`"
                                :title="rutaInfo?.nombre"/>
                        </div>
                    </mdb-container>

                    <div class="d-flex flex-column col-12 my-2 d-md-none">
                        <span class="spainhn-sections-title text-uppercase">{{ $t("default.HOME_RESULTS_MAP_LABEL") }}</span>
                        <div class="d-flex flex-wrap justify-content-center">
                            <mapa-card :latitud="latitud" :longitud="longitud" :markers="markers"/>
                        </div>
                    </div>

                    <!-- TODO: Change lugar to the i18n label -->
                    <div class="d-flex flex-column pt-3 col-12 col-xxl-4 order-xl-1 order-last" v-if="eventosRecomendados.length > 0"> 
                        <span class="spainhn-sections-title text-uppercase">{{ $t('default.MICROSITES_TICKETS_RECOMMENDATIONS') }}</span>
                        <div class="d-flex flex-wrap justify-content-evenly px-0">
                            <recommendations-card
                                v-for="(paqueteM) in paquetes.filter( p => p.tipo_de_paquete === 'pack_monumentos')" :key="paqueteM._id"
                                class="my-2"
                                :title="paqueteM.webName"
                                :showDefault="false"
                                :text="$t('default.CARDS.PLACE', {msg: paqueteM.monumentName})"
                                :price-description="paqueteM?.precioOrientativo ? 
                                            $t('default.CARDS.START_FROM', { msg: getPrice(paqueteM.precioOrientativo)}) :
                                            ''"
                                :image-url="`${imagenesUrl}/paquetes_monumentos/${paqueteM.oldId}/${paqueteM.banner}`"
                                :showBuyButton="true"
                                @goTo="() => goToMicrositioPaqueteMonumento( { name: paqueteM.name, id: paqueteM._id } )"
                                @buy="() => goToBuy( paqueteM, true )"
                                />

                            <!-- Poner aquí las visitas -->
                            <recommendations-card v-for="(evento, index) in eventosRecomendados" v-bind:key="index"
                                class="my-2"
                                :title="evento.webName"
                                :nombreUrl="evento.visitaId"
                                :fecha="evento.fechas"
                                @goTo="goToEntrada"
                                :tipo="'Entrada'"
                                :imageUrl="`${imagenesUrl}/visitas_castillos/${evento.oldId}/${evento.imagen}`"
                                v-bind:class="{'d-none':index > 2}"
                            />
                        </div>
                    </div>

                    <div class="d-xxl-flex mx-auto flex-column pt-3 h-100 col-12 order-md-last col-xxl-4 d-none pe-0" v-else>
                        <div class="flex-grow spainhn-bg-gris-cajas ps-4 pe-4 mt-2 pt-3 d-flex flex-column text-start spainhn-text">
                            <h2 class="d-flex fw-bold" style="font-weight:700; font-size:28pt">{{ $t('default.MICROSITES_LOCATION') }}</h2>
                            <div class="spainhn-text">{{address}}</div>
                            <div class="spinhn-text text-start fw-bold">{{ $t('default.MICROSITES_INDICATIONS') }}:</div>
                            <div class="spinhn-text text-start">
                                <p style="font-family:Regular !important; font-family:Montserrat !important; font-size:12pt !important; font-weight:400 !important;" 
                                    v-html="micrositeData.webDirections"></p>
                                </div>
                        </div>

                    </div>


                </div>
            </div>

            <div class="container-fluid px-lg-4 mb-4 services-wrap d-md-flex">
                <div class="row w-100 px-lg-4">
                    <div class="pt-3 pe-3 col-12 order-md-first col-xxl-12">
                        <div class="d-flex flex-column">

                            <div class="mt-3 text-start d-none d-lg-block ">
                                <span class="mb-0 pb-0 pt-2 spainhn-sections-title text-start text-uppercase" >{{ $t('default.MICROSITES_SCHEDULE') }}</span>
                                <div class="w-100 mt-0 pt-0 mb-1" style="height:2vh; border-color:var(--spainhn-rojo-corporativo) !important; border-width: medium !important;"></div>

                                <div class="spinhn-text column-count-2 text-start">
                                    <p class="column-count-responsive" style="line-height-step: 50vh;" v-html="micrositeData.webSchedules"></p>
                                </div>
                            </div>
                            <div class="w-100 mt-0 pt-0 mb-4 d-none d-lg-block" id="services" v-if="bodas || alojamiento || espacios || restaurante || museo" style="height:9vh; border-color:var(--spainhn-rojo-corporativo) !important; border-width: medium !important;"></div>
                            <div class="mt-3 text-start d-none d-lg-block pt-0"  v-if="bodas || alojamiento || espacios || restaurante || museo">
                                <span class="mb-0 pb-0 mt-t spainhn-sections-title text-start text-uppercase" >{{ $t('default.MICROSITES_OFFERED_SERVICES') }}</span>
                                <div class="w-100 mt-0 pt-0 mb-1" style="height:2vh; border-color:var(--spainhn-rojo-corporativo) !important; border-width: medium !important;"></div>

                                <div class="d-flex justify-content-start gap-3 flex-wrap align-content-center flex-wrap">
                                    <div v-if="bodas" class="p-2 spainhn-bg-gris-cajas  html-container service-item " style="flex-basis: 49%;">
                                        <h5 class="fw-bold">{{ $t("default.SERVICES.WEDDINGS") }}</h5>
                                        <p v-html="micrositeData.webWeddingDescription"></p>
                                    </div>
                                    <div v-if="espacios" class="p-2 spainhn-bg-gris-cajas service-item html-container " style="flex-basis: 49%;">
                                        <h5 class="fw-bold">{{ $t("default.SERVICES.SPACES") }}</h5>
                                        <p v-html="micrositeData.webMiceDescription"></p>
                                    </div>
                                    <div v-if="museo" class="p-2 spainhn-bg-gris-cajas service-item html-container " style="flex-basis: 49%;">
                                        <h5 class="fw-bold">{{ $t("default.SERVICES.MUSEUM") }}</h5>
                                        <p v-html="micrositeData.webMuseumDescription"></p>
                                    </div>
                                    <div v-if="restaurante" class="p-2 spainhn-bg-gris-cajas service-item html-container " style="flex-basis: 49%;">
                                        <h5 class="fw-bold">{{ $t("default.SERVICES.RESTAURANT") }}</h5>
                                        <p v-html="micrositeData.webRestauranteDescription"></p>
                                    </div>
                                    <div v-if="alojamiento" class="p-2 spainhn-bg-gris-cajas service-item html-container " style="flex-basis: 49%;">
                                        <h5 class="fw-bold">{{ $t("default.SERVICES.ACOMMODATIONS") }}</h5>
                                        <p v-html="micrositeData.webHostingDescription"></p>
                                    </div>
                                </div>

                            </div>

                            <div class="d-md-flex d-none">
                                <MultimediaComponent :video-id="videoId" :class="{'d-none': !videoId}"/>
                            </div>
                            <div class="text-start pt-1" v-if="restaurantes.length > 0 && actividades.length > 0">
                                <strong class="spainhn-sections-title text-start text-uppercase">{{ $t('default.MICROSITES_SERVICES_RECOMMENDATIONS') }}</strong>
                            </div>
                            <div v-if="restaurantes.length > 0">
                                <p class="text-md-start mb-0 spainhn-subheader-info text-uppercase"><strong>{{ $t('default.MICROSITES_RESTAURANT_RECOMMENDATIONS') }}</strong></p>
                                <div class="d-flex flex-column flex-md-row mb-0">
                                    <cards-thumbnails v-for="(restaurante, index) in restaurantes" v-bind:key="index"
                                        :monument="restaurante.webName"
                                        :nombreUrl="restaurante._id"
                                        tipo="restaurantes"
                                        v-bind:class="{'d-none':index > 2}"
                                        :imageUrl="`${imagenesUrl}/restaurantes/${restaurante.oldId}/${restaurante.banner}`"/>
                                </div>
                                <mdb-btn color="indigo" class="spainhn-button mt-3" v-bind:class="{'d-none':!(restaurantes.length > 3)}" 
                                     @click="goToRestaurantes">{{ $t('default.MICROSITES_RESTAURANT_BUTTON') }}</mdb-btn>

                            </div>
                            <div class="mt-3" v-if="actividades.length > 0">
                                <p class="text-md-start spainhn-subheader-info text-uppercase"><strong>{{ $t('default.MICROSITES_ACTIVITIES_RECOMMENDATIONS') }}</strong></p>
                                <div class="d-flex mb-0 pt-2 flex-column flex-md-row">
                                    <cards-thumbnails v-for="(actividad, index) in actividades" v-bind:key="index"
                                        :monument="actividad.webName"
                                        :nombreUrl="actividad._id"
                                        tipo="actividades"
                                        v-bind:class="{'d-none':index > 2}"
                                        :imageUrl="`${imagenesUrl}/actividades/${actividad.oldId}/${actividad.banner}`"/>
                                </div>
                                <mdb-btn color="indigo" class="spainhn-button mt-3" v-bind:class="{'d-none':!(actividades.length > 3)}" 
                                    @click="goToActividades">{{ $t('default.MICROSITES_ACTIVITIES_BUTTON') }}</mdb-btn>
                            </div>
                            <!-- Paquetes de experiencias -->
                            <div class="text-start pt-1" v-if="paquetes.filter( p => p.tipo_de_paquete === 'pack_experiencias').length > 0" >
                                <strong class="spainhn-subtitle-black">{{ $t('default.MICROSITES_PACKAGES') }}</strong>
                                <div class="w-100 border-bottom mb-3" style="height:2vh; border-color:var(--spainhn-rojo-corporativo) !important; border-width: medium !important;"></div>

                            </div>
                            <div v-if="paquetes.filter( p => p.tipo_de_paquete === 'pack_experiencias').length > 0">
                                <p class="text-md-start mb-0"><strong style="color:rgb(150,150,150); font-weight:600; font-size:24pt">{{ $t('default.MICROSITES_EXPERIENCES_PACKAGES') }}</strong></p>
                                <div class="d-flex flex-column flex-md-row mb-0">
                                    <cards-thumbnails v-for="(paquete, index) in paquetes.filter( p => p.tipo_de_paquete === 'pack_experiencias')" v-bind:key="index"
                                        :monument="paquete.nombre || paquete.webName"
                                        :nombreUrl="paquete._id"
                                        tipo="Entrada"
                                        @goTo="() => goToPaquete(paquete)"
                                        v-bind:class="{'d-none':index > 2}"
                                        :imageUrl="`${imagenesUrl}/paquetes_prestadores/${paquete.oldId}/${paquete.banner}`"/>
                                </div>
                                <mdb-btn color="indigo" class="spainhn-button mt-3" v-bind:class="{'d-none':!(restaurantes.length > 3)}" 
                                     @click="goToRestaurantes">{{ $t('default.MICROSITES_RESTAURANT_BUTTON') }}</mdb-btn>

                            </div>
                        </div>
                    </div>

                    <div class="flex-column pt-3 h-100 col-12 order-md-last col-xxl-4 d-none d-lg-flex d-xl-none" v-bind:class="{ 'd-none':(eventosRecomendados.length == 0) }">
                        <div class="flex-grow spainhn-bg-gris-cajas ps-4 pe-4 mt-2 pt-3 d-flex flex-column text-start spainhn-text">
                            <span class="d-flex spainhn-sections-title">{{ $t('default.MICROSITES_LOCATION') }}</span>
                            <div class="spainhn-text">{{address}}</div>
                            <div class="spinhn-text text-start fw-bold">{{ $t('default.MICROSITES_INDICATIONS') }}:</div>
                            <div class="spinhn-text text-start">
                                <p style="font-family:Regular !important; font-family:Montserrat !important; font-size:12pt !important; font-weight:400 !important;" v-html="micrositeData.webDirections"></p>
                            </div>

                            
                            <!-- <div class="spinhn-text text-start fw-bold" style="font-weight:700; font-size:34pt">{{ $t('default.MICROSITES_SCHEDULE') }}</div>
                                
                                <div class="spinhn-text text-start">
                                    
                                    <p v-html="horarios[selectedIdioma].texto"></p>
                                </div> -->
                            </div>
                            <div class="d-flex justify-content-center">
                                <MultimediaComponent :video-id="videoId" :class="{'d-none': videoId}"/>
                            </div>
                    </div>

                </div>
            </div>

            <welcome-modal 
                :popup-start="showWelcome" 
                :title="welcomeTitle" 
                :subtitle="welcomeSubtitle"
                :image-url="welcomeData.imageUrl"
                @close="showWelcome = false"
                @goTo="() => $router.push(`/castillos/tarifas/${$route.params.monumentoNombre}/${welcomeData.visitaId}`)"
                :color="'danger'"/>

            <!-- <div class="d-flex mb-5">
                <div class="d-flex justify-content-around px-0 mx-auto w-100 flex-wrap">
                    <cards-2 v-for="(edificio, index) in edificios" v-bind:key="index"
                        :monument="edificio.nombre[0].nombre"
                        :imageUrl="edificio.imagen"
                        :text="edificio.descripcion"
                        :id="edificio.castilloId"
                        role="button"/>
                </div>
            </div>     -->

        </div>
        <mdb-container fluid class="mt-3">
            <ComponentsCloud />
        </mdb-container>
    </default-layout>
</template>

<script>

import DefaultLayout from '../layouts/DefaultLayout.vue'
// import HeaderImage from '../components/HeaderImage.vue'
import IconBase from '../components/IconBase.vue';
import WhiteLoader from '../components/Loaders/WhiteLoader.vue';
// import IconCasttle from '../components/icons/IconCasttle.vue';
// import IconPalace from '../components/icons/IconPalace.vue';
// import IconRealPalace from '../components/icons/IconRealPalace.vue'
// import IconArt from '../components/icons/IconArt.vue'
// import IconWalledEnclosure from '../components/icons/IconWalledEnclosure.vue'
// import IconMonastery from '../components/icons/IconMonastery.vue'

import ApiService from '../services/ApiService';
import Cards4 from '../components/Cards4.vue';
import CardsThumbnails from '../components/CardsThumbnails.vue';
// import CardsThumbnails3 from '../components/CardsThumbnails3.vue';
import IconCarrito from '../components/icons/IconCarrito.vue';
import WelcomeModal from '../components/WelcomeModal.vue';
import SpainhnNavigationBreadcrumb from '../components/SpainhnNavigationBreadcrumb.vue';
import CollapsableElement from '../components/CollapsableElement';
import RecommendationsCard from '../components/RecommendationsCard';
import MultimediaComponent from '../components/MultimediaComponent.vue';
import RutasCard from '../components/RutasCard.vue';
import MapaCard from '../components/MapaCard.vue';
import IconTicket from '../components/icons/IconTicket';
import BuyComponent from '../components/BuyComponent.vue';
import ComponentsCloud from '../components/ComponentsCloud'
// import IconTicket from '../components/icons/IconTicket.vue'
// import Cards from '../components/Cards.vue';

export default {
    components:{
    DefaultLayout,
    IconBase,
    // IconCasttle,
    // IconPalace, 
    // IconRealPalace, 
    // IconArt, 
    // IconWalledEnclosure,
    // IconMonastery, 
    // Cards4,
    CardsThumbnails,
    // CardsThumbnails3,
    // IconCarrito,
    WelcomeModal // Cards
    ,
    SpainhnNavigationBreadcrumb,
    CollapsableElement,
    RecommendationsCard,
    MultimediaComponent,
    RutasCard,
    MapaCard,
    BuyComponent,
    ComponentsCloud,
    WhiteLoader
    // IconTicket
},
    data(){
        return{
            micrositeData: {
                webName: "",
                webDescription: "",
                webWeddingDescription: "",
                webMuseumDescription: "",
                webMiceDescription: "",
                webHostingDescription: "",
                webRestauranteDescription: "",
                coordenadas: {
                    lat: "",
                    lng: "",
                }
            },
            thumbnailsPosition: 0,
            monumentoNombre:"",
            address:null,
            videoId: null,
            edificios:[],
            imagenes:[],
            indicaciones:[],
            horarios:[],
            webHorarios: "",
            castilloId: null,
            activeImage: 0,
            nombreUrl: null,
            restaurantes:[],
            actividades:[],
            coordenadas: null,
            markers:[],
            latitud: null,
            longitud: null,
            monumentoOldId: null,
            slide:0,
            sliding:null,
            eventosRecomendados:[],
            museo: false,
            restaurante: false,
            espacios: false,
            bodas: false,
            alojamiento: false,
            hotelbeds: false,
            entradasNumber: false,
            rutaInfo: null,
            monumentoNombres: [],
            descripciones: [],
            // indicaciones: [],
            idiomaIndex: 0,
            imagenesUrl: null,
            experiencias: 0,
            eventos: 0,
            apiExterno: false,
            apiExternoUrl: null,
            clorianPos: null,

            audioguiaOn: false,
            audioguiaUrl: null,
            podcastOn: false,
            podcastUrl: null,
            welcomeData: {
                active: false,
                imageUrl: null,
                visitaId: null
            },
            welcomeMessages: [],
            welcomeMessage: {
                title: null,
                subtitle: null
            },
            showWelcome: false,
            links:[
                { text: null },
                { text: null}
            ],
            comunidadAutonoma: null,
            provincia: null,
            showFullText: false,
            paquetes: [],
            // Con esta variable determinamos el status del icono        

            // nuevas descripciones ha agregar
            bodasDescripciones: [],
            alojamientoDescripciones: [],
            espaciosDescripciones: [],
            restauranteDescripciones: [],
            museoDescripciones: [],

            section: null,
            windowWidth: window.innerWidth,
            webName: "",

            loading: false,
            agrupacionInfo: [], // Inicializar como array vacío
            activeTab: 0,
        }
    },
    methods:{
        encodeUrl(name = '') {
            let rawName = name.replaceAll(',', '');
            rawName = rawName.replaceAll('.', '');

            let sanitizedName = rawName.normalize("NFD").replace(/[\u0300-\u036f]|[^0-9a-zA-Z]+[\u0020]/g, '')
            let sanitizedNameLowercase = sanitizedName.toLowerCase().replace(/[\u0020]/g, '-');

            return sanitizedNameLowercase
        },
        goToMicrositioPaqueteMonumento( { name , id } ){
            console.log('🚀 ~ goToMicrositioPaqueteMonumento ~ name:', name)
            this.$router.push( { name: 'MicrositioPaqueteMonumento', params: { paqueteNombre: this.encodeUrl(name) || 'name', paqueteId: id } } )
        },
        goToBuy( data, paqueteMonumento=false ) {
            if( data.apiDeVentasActive && data.apiDeVentasUrl !== 'clorian' ){
                this.$toast.success(this.$t("default.NOTIFICATIONS.REDIRECT"));
                setTimeout( () => {
                    window.open(`${data.apiDeVentasUrl}?idProducto=${data.oldId}`, '_blank');
                }, 2000 )
            }else{

                if( data.imageLabel === 'paquetes_prestadores'){
                    this.$router.push({ name: "ReservarPackExperiencias",  query: { tipo: 'paquete', id: data._id } } );
                }
                else if(data.imageLabel === "servicios_prestadores"){
                    this.$router.push({ name: "ReservarPackExperiencias",  query: { tipo: 'servicio', id: data._id } } );
                }
                else if( paqueteMonumento ){
                    this.$router.push({ name: "ReservarPackMonumentos",  query: { tipo: 'monumentos', id: data._id } } );
                }
                else{
                    this.$router.push(`/castillos/reservar/idvisita:${data.entradaId}`)
                }
            }
        },
        toggleFullText(){
            if( this.showFullText )
                this.showFullText = false;
            else
                this.showFullText = true;
        },
        goToAudioguia(){
            let $vm = this;
            window.open($vm.audioguiaUrl, "_blank")
        },
        goToExternalApi(){
            let $vm = this;
            window.open($vm.apiExternoUrl, "_blank")
        },
        showContent(){
        },
        prevImage(){
            let $vm = this;
            if($vm.activeImage == 0){
                $vm.activeImage = $vm.imagenes.length;
            }
        },
        goToContact(){
            let $vm = this;
            $vm.$router.push('/contacto')
        },
        goToAlojamientosCercanos(){
            let $vm = this;
            $vm.$router.push($vm.$route.path + '/alojamientos')
        },
        goToEntradas(){
            let $vm = this;
            $vm.$router.push("/castillos/tarifas/" + this.micrositeData.nombreNormalizado)
        },
        goToExperiences(){
            let $vm = this;
            $vm.$router.push("/experiencias-exclusivas/" + this.micrositeData.nombreNormalizado)

        },
        goToEventos(){
            let $vm = this;
            $vm.$router.push("/eventos-singulares/" + $vm.micrositeData.nombreNormalizado )
        },
        goToBodas(){
            let $vm = this;
            // $vm.$router.push( $vm.$route.path +'/'+ $vm.castilloId + '/bodas')
            $vm.$router.push( $vm.$route.path + '/bodas')
            
        },
        goToEspacios(){
            let $vm = this;
            $vm.$router.push( $vm.$route.path +'/espacios')
        },
        goToRestaurante(){
            let $vm = this;
            $vm.$router.push( $vm.$route.path +'/restaurante')
        },
        goToMuseo(){
            let $vm = this;
            $vm.$router.push( $vm.$route.path +'/museo')
        },
        goToAlojamiento(){
            let $vm = this;
            // $vm.$router.push( $vm.$route.path +'/'+ $vm.castilloId + '/alojamiento')
            $vm.$router.push( $vm.$route.path + '/alojamiento')

        },
        goToEntrada(evento){
            console.log("🚀 ~ goToEntrada ~ evento:", evento)
            let $vm = this;
            // console.log( evento );
            // console.log( this.monumentoNombre );
            $vm.$router.push("/castillos/tarifas/" + $vm.monumentoNombre + '/' + evento)
        },
        masRutas(){
            let $vm = this;
            $vm.$router.push("/castillos/rutas/" + $vm.castilloId)
        },
        goToRutas(){
            let $vm = this;
            $vm.$router.push("/rutas-recomendadas")
        },
        onSlideStart() {
            this.sliding = true
        },
        onSlideEnd() {
            this.sliding = false
        },
        goToActividades(){
            let $vm = this;
            $vm.$router.push("/actividades/" + $vm.micrositeData.nombreNormalizado )
        },
        goToRestaurantes(){
            let $vm = this;
            $vm.$router.push("/Restaurantes/" + $vm.micrositeData.nombreNormalizado)
        },
        changeSlide(index){
            let $vm = this;
            $vm.slide = index;
            let numeroDeImagenes = $vm.imagenes.length;
            let totalWidth = numeroDeImagenes * 150;
            let tempPosition = $vm.thumbnailsPosition;
            let containerWidth = $vm.$refs.imageSelector.clientWidth
            let distanciaMenor = index - 0;
            let distanciaMayor = numeroDeImagenes - index;

            let pixelsToMove = 0;
            if(index % 2){
                pixelsToMove = 120 * index;
            }
            else{
                pixelsToMove = 150* index;
            }
            // let pixelsToMove = 120 * index;
            let steps = Math.abs(index - tempPosition);
            if(steps == 0){
                pixelsToMove = 0;
            }
            let posicionesDisponibles = Math.abs(index - numeroDeImagenes)
            if((posicionesDisponibles * 300) > containerWidth){

                if(tempPosition > index){
                    if(pixelsToMove > 0){
                        pixelsToMove = 0;
                    }
                    else{
                    pixelsToMove *= -1;

                    }
                    // if(index < 2){
                    //     pixelsToMove = 0;
                    // }
                    if(totalWidth > containerWidth){
                        $vm.$refs.imageSelector.style.transform = `translate(${pixelsToMove}px)`;

                    }
                }
                else if(tempPosition < index){
                    pixelsToMove *= -1;
                    if(pixelsToMove > containerWidth){
                        pixelsToMove = 0
                    }

                    if(totalWidth > containerWidth){
                        $vm.$refs.imageSelector.style.transform = `translate(${pixelsToMove}px)`;

                    }
                }
            }
            $vm.thumbnailsPosition = index;
        },
        updateMicrositeData( data ){

            this.micrositeData = { ...data };
            this.webName = data.webName;
            this.address = data.direccion;
            this.descripcion = data.descripcion;
            this.descripciones = data.descripciones;
            this.indicaciones = data.indicaciones;
            this.horarios = data.horarios;
            this.monumentoNombres = data.nombres;
            // this.imagenes = data.imagenes;
            this.castilloId = data.id;
            this.coordenadas = data.coordenadas;
            this.videoId = data.codigoYoutube;
            this.monumentoOldId = data.oldId;
            this.museo = data.museo;
            this.restaurante = data.restaurante;
            this.alojamiento = data.alojamiento;
            this.hotelbeds = data.hotelbeds;

            this.bodas = data.bodas;
            this.espacios = data.espacios;
            this.entradasNumber = data.entradas;
            this.imagen = data.imagen;

            this.experiencias = data.experiencias;
            this.eventos = data.eventos;

            this.apiExterno = data.apiDeVentasActive;
            this.apiExternoUrl = data.apiDeVentasUrl;
            this.clorianPos = data.clorianPos;

            this.audioguiaOn = data.audioguiaOn;
            this.audioguiaUrl = data.audioguiaUrl;
            this.podcastOn = data.podcastOn;
            this.podcastUrl = data.podcastUrl;

            this.welcomeData.active = data.welcomeActive ?? false;
            this.welcomeData.visitaId = data.visitaWelcome;
            this.welcomeMessages = data.welcomeMessages ?? [];
            this.welcomeData.imageUrl = data.welcomeImageUrl;

            this.municipio = data.municipio;
            this.comunidadAutonoma = data.comunidadAutonoma;

            if( this.welcomeData.active ){
                this.showWelcome = true;
            }

            this.latitud = parseFloat(data.coordenadas.lat);
            this.longitud = parseFloat(data.coordenadas.lng);

            let newMarker = {
                id: 0,
                position: {
                lat: this.latitud,
                lng: this.longitud
                },
                opacity: 1,
                draggable: false,
                enabled: true,
                clicked: 0,
                rightClicked: 0,
                dragended: 0,
                ifw: true,
                ifw2text: 'This text is bad please change me :( '
            }
            this.markers.push(newMarker);

            this.provincia  = data.provincia;
            this.comunidad = data.comunidad;
            this.municipio = data.municipio
            this.links = [
                { text: this.provincia },
                { text: this.comunidad }
            ];

            this.bodasDescripciones = data?.bodasDescripciones;
            this.alojamientoDescripciones = data?.alojamientoDescripciones;
            this.espaciosDescripciones = data?.espaciosDescripciones;
            this.restauranteDescripciones = data?.restauranteDescripciones;
            this.museoDescripciones = data?.museoDescripciones;

        },
        async getPaquetes(id){
            let $vm = this;
            const _language = this.$store.getters.getIdioma;
            let paquetes = await ApiService.getPaquetes(id, _language);
            return paquetes.data.filter(paquete => paquete.web !== false && paquete.web !== 0);
        },
        goToPaquete(paquete){
            console.log("🚀 ~ goToPaquete ~ paquete:", paquete)
            this.$router.push(`/paquete/${paquete.nombres[0].texto.toLowerCase().replaceAll(" ", "-")}/${paquete._id}`);
        },
        zanitizeColorHTMLString(string){
            const res = string?.replaceAll('color:','color-disabled-style-by-zanitizer')
            return res
        },
        getPrice( precioOrientativo ){
            if( precioOrientativo ){
                if( isNaN(Number(precioOrientativo)) ){
                    return '';
                }else{
                    return `${parseFloat(Number(precioOrientativo))?.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })}`
                }
            }else{
                return '';
            }
        },
        async getAgrupacionData() {
            try {
                const result = await ApiService.getMonumentAgrupation(this.castilloId);
                this.agrupacionInfo = result.data;
            } catch (error) {
                console.error('Error al obtener la agrupación:', error);
            }
        },
        handleTabClick(monumento) {
            this.$router.push({
                name: 'Micro_Sitios',
                params: { monumentoNombre: monumento.nombreNormalizado }
            });
        },
        updateActiveTab() {
            const index = this.agrupacionInfo.findIndex(
                m => m._id === this.castilloId
            );
            if (index !== -1) {
                this.activeTab = index;
            }
        }
    },
    setup() {
        
    },
    async created(){
        this.imagenesUrl = process.env.VUE_APP_IMAGES_URL;
        let $vm = this;
        $vm.monumentoNombre = $vm.$route.params.monumentoNombre;
        
        const _language = this.$store.getters.getIdioma;
        this.$i18n.locale = _language;
        try{
            this.loading = true;
            const result = await ApiService.getEdificacion( _language, this.monumentoNombre );
            const data = result.data; 
            this.updateMicrositeData( data );
    
            ApiService.getRestaurantesByMonumentoId($vm.$i18n.locale, $vm.castilloId)
                .then( result => {
                    // console.log(result.data);
                    $vm.restaurantes = [...result.data];
                })
                .catch( err=> {
                    console.log(err);
                })
    
            ApiService.getActividadesByMonumentoId($vm.$i18n.locale, $vm.castilloId)
                .then( result => {
                    // console.log(result.data);
                    $vm.actividades = [...result.data]
                })
                .catch( err=> {
                    console.log(err);
                })
    
            ApiService.getImagenesByMonumento(data.oldId)
                .then(res => {
                    // Primero quitamos los objetos null
                    let tempImagenes = res.data.images.filter( i => i.visible );
    
                    // console.log(tempImagenes);
                    tempImagenes.sort( function(a,b){
                        return a.order - b.order
                    })
                    this.imagenes = tempImagenes;
                })
                .catch(err => {
                    console.log(err);
                })
    
            ApiService.getEventosByMonumento(_language, $vm.castilloId)
                .then(res =>{
                    this.eventosRecomendados = [...res.data.filter( e => e.restringirVentaIndividual !== true) ];
                    // Ponemos al frente los eventos que tienen fechas asignadas
                    this.eventosRecomendados.sort( function(a,b){                            
                        if(b.fechas.length > 0 && a.fechas.length > 0){
                            return new Date(a.fechas[0]) - new Date(b.fechas[0])
                        }
                        else if(b.fechas.length > 0 && a.fechas.length == 0){
                            return 1;
                        }
                        else if(b.fechas.length == 0 && a.fechas.length > 0){
                            return -1;
                        }
                        else if(b.fechas.length == 0 && a.fechas.length == 0){
                            return -1;
                        }
                        else{
                            return 0;
                        }
                    } )
    
                })
                .catch(err =>{
                    console.log(err)
                })
                
            ApiService.getUniqueRoute(_language, $vm.castilloId)
                .then(res => {
                    let $vm = this;
                    $vm.rutaInfo = res.data;                    
                })
                .catch(err => {
                    console.log(err);
                })
    
            this.getPaquetes($vm.castilloId)
                .then(res => {
                    $vm.paquetes = res;
                })
                .catch(err => {
                    console.log(err);
                })
    
                this.section = this.$route.hash.slice(1);
                if(this.section){
                    if(this.windowWidth > 990)
                        setTimeout(() => {
                            document.getElementById(this.section).scrollIntoView({ behavior: 'smooth' });
                        }, 1200);
                    else{
                        setTimeout(() => {
                            document.getElementById(this.section + '-small').scrollIntoView({ behavior: 'smooth' });
                        }, 1200);
                    }
                }

            await this.getAgrupacionData();
            this.updateActiveTab();

        }catch( error ){
            console.log( error );
        }finally{
            this.loading = false;
        }

        // this.descripciones = data.descripciones;
            
    },
    computed: {
        welcomeTitle(){
            const language = this.$i18n.locale ?? 'es';
            let welcomeTitle = "";

            welcomeTitle = this.welcomeMessages.filter( wm => wm.idioma === language ).map( wm => wm.title )[0];
            return welcomeTitle;
        },
        welcomeSubtitle(){
            const language = this.$i18n.locale ?? 'es';
            let welcomeSubtitle = "";
            welcomeSubtitle = this.welcomeMessages.filter( wm => wm.idioma === language ).map( wm => wm.subtitle  )[0];
            return welcomeSubtitle;

        },
        isCastillosSelected(){
            let $vm = this;
            if($vm.selectedType === "Castillos"){
                $vm.castillosColor = $vm.activeColor;
                $vm.descripciones = $vm.$t('default.castillosDescriptionText');
                return true;
            }
            else{
                $vm.castillosColor = $vm.disabledColor;
                return false;  
            } 
        },
        selectedIdiomaIndex(){
            let $vm=this;
            let idiomaIndex = 0;
            if($vm.$i18n.locale == 'es'){
                idiomaIndex = 0;
            }
            else if($vm.$i18n.locale == 'en'){
                idiomaIndex = 1;
            }
            else if($vm.$i18n.locale == 'fr'){
                idiomaIndex = 2;
            }
            else if($vm.$i18n.locale == 'de'){
                idiomaIndex = 3;
            }else if($vm.$i18n.locale == 'ja'){
                idiomaIndex = 4;
            }
            return idiomaIndex;
        },
        selectedIdioma(){
            let $vm=this;
            
            return $vm.$i18n.locale;
        },
        // Devuelve el id de la ruta
        rutaId(){
            let $vm = this;
            if($vm.rutaInfo != null){
                return $vm.rutaInfo.rudaId;
            }
            else{
                return null;
            }
        },
        // Devuelve el nombre de la ruta
        rutaNombre(){
            let $vm = this;
            if( $vm.rutaInfo ){
                return $vm.rutaInfo.nombre;
            }
            else{
                return null;
            }
        },
        rutaCompleteId(){
            let $vm = this;
            if( $vm.rutaInfo ){
                return $vm.rutaInfo._id;
            }
            else{
                return null;
            }
        },
        nombreDeMonumentoPorIdioma(){
            let $vm = this;
            return this.webName;
            // if( $vm.monumentoNombres[$vm.selectedIdiomaIndex] ){
            //     return $vm.monumentoNombres[$vm.selectedIdiomaIndex].texto;
            // }
            // else{
            //     return $vm.monumentoNombre;
            // }
        }
    },
    watch: {
        // Añadir este watcher
        '$route'(to, from) {
            if (to.name === 'Micro_Sitios') {
                this.$nextTick(() => {
                    this.updateActiveTab();
                });
            }
        },

        agrupacionInfo: {
            handler() {
                this.updateActiveTab();
            },
            immediate: true
        },
        castilloId: {
            handler() {
                this.$nextTick(() => {
                    this.updateActiveTab();
                });
            },
            immediate: true
        }
    }
}
</script>


<style>
/* Removemos scoped para asegurarnos que los estilos alcancen los componentes hijos */
.monumentos-tabs .nav-tabs {
    border-bottom: none !important;
    margin-top: 2rem !important;
}

.monumentos-tabs .nav-tabs .nav-link {
    color: #850B0B !important;
    font-weight: 500 !important;
    border: none !important;
    margin-right: 4px !important;
    border-radius: 4px !important;
    background-color: #fff !important;
    transition: all 0.3s ease !important;
    padding: 8px 16px !important;
}

.monumentos-tabs .nav-tabs .nav-link:hover {
    background-color: #850B0B !important;
    color: white !important;
}

.monumentos-tabs .nav-tabs .nav-link.active {
    color: white !important;
    background-color: #850B0B !important;
    font-weight: bold !important;
    box-shadow: 0 2px 4px rgba(133, 11, 11, 0.2) !important;
}
</style>